import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/account/login/login.component';
import { LogoutComponent } from './pages/account/logout/logout.component';
import { PlantillaComponent } from './pages/plantilla/plantilla.component';
import { ActualizaDatosComponent } from './pages/account/actualiza-datos/actualiza-datos.component';     
import { DesbloqueaUsuarioComponent } from './pages/account/desbloquea-usuario/desbloquea-usuario.component';
import { RestablecerContrasenaComponent } from './pages/account/restablecer-contrasena/restablecer-contrasena.component';
import { AuthGuard } from './services/auth/auth.guard';
import { DocumentoNoDisponibleComponent } from './pages/error/documento-no-disponible/documento-no-disponible.component';
import { RestablecerVigenciaComponent } from './pages/account/restablecer-vigencia/restablecer-vigencia.component';
import { RegistroStepperComponent } from './pages/account/login/registro-stepper/registro-stepper.component';
import { registroDisenoGuard } from 'src/app/services/seguros-atlas/guards/registro-diseno.guard';
import { registroSalidaGuard } from 'src/app/services/seguros-atlas/guards/registro-salida.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'login/registrate', component: RegistroStepperComponent, canActivate: [registroDisenoGuard], canDeactivate: [registroSalidaGuard] },
  { path: 'login/:ruta', component: LoginComponent },
  { path: 'logout', component: LogoutComponent, },
  { path: 'documento-no-dispobible', component: DocumentoNoDisponibleComponent },
  { path: 'template', component: PlantillaComponent },
  { path: 'seguros-atlas', loadChildren: () => import('./pages/seguros-atlas/seguros-atlas.module').then(m => m.SegurosAtlasModule) },
  { path: '', loadChildren: () => import('./pages/seguros-atlas/atlas-card/atlas-card.module').then(m => m.AtlasCardModule) },
  { path: '', loadChildren: () => import('./pages/seguros-atlas/card/card.module').then(m => m.CardModule) },
  { path: '', loadChildren: () => import('./pages/seguros-atlas/atlas-domiciliacion/domiciliacion.module').then(m => m.DomiciliacionModule) },
  { path: 'actualiza-datos', component: ActualizaDatosComponent },
  { path: 'actualiza-datos/:data', component: ActualizaDatosComponent },
  { path: 'desbloquea-usuario/:data', component: DesbloqueaUsuarioComponent },
  { path: 'restablecer-vigencia', component: RestablecerVigenciaComponent },
  { path: 'restablecer-contraseña/:data', component: RestablecerContrasenaComponent },
  { path: 'generales', loadChildren: () => import('./pages/generales/generales.module').then(m => m.GeneralesModule) },
  { path: 'prospectos', loadChildren: () => import('./pages/prospecto/prospecto.module').then(m => m.ProspectoModule) },
  { path: 'proveedores', loadChildren: () => import('./pages/proveedores/proveedores.module').then(m => m.ProveedoresModule) },
  { path: 'facturacion', loadChildren: () => import('./pages/facturacion/facturacion.module').then(m => m.FacturacionModule) },
  { path: '', loadChildren: () => import('./pages/paginas.module').then(m => m.PaginasModule) },
  { path: '**', redirectTo: '/dashboard-agente', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }